/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeviceUUID } from 'device-uuid';
import {
  setApiBaseURL,
  setApiVersion,
  setDeviceUUID,
  setPlatform,
  selectDeviceUUID,
  setIsKeyboardOpened,
} from 'getaway-data-layer';
import config from '../env.config';

type props = {
  children: React.ReactElement;
};

const Setup = ({ children }: props) => {
  const dispatch = useDispatch();
  const deviceUUID = useSelector(selectDeviceUUID);

  useEffect(() => {
    dispatch(setIsKeyboardOpened(false));
    dispatch(setPlatform('browser'));
    dispatch(setApiVersion(config.api.apiVersion));
    dispatch(setApiBaseURL(config.api.baseURL));
    if (!deviceUUID) {
      dispatch(setDeviceUUID(new DeviceUUID().get()));
    }
  }, []);

  return children;
};

export default Setup;
